import { ApiListResponse } from './common.model'

export interface IViewUser {
  id: string
  firstName: string
  lastName: string
  userName: string
}

export type IGetUserListResponse = ApiListResponse<Array<IViewUser>>

export enum GROUP_TYPE_OPTIONS {
  BANK_ACCESS = 1,
  CLIENT_ACCESS = 2,
}

export enum EXPIRATION_TYPE {
  DOES_NOT_EXPIRE = 1,
  EXPIRE_X_MINUTES = 2,
  EXPIRE_X_DAYS = 3,
}

export interface UserRole {
  id: string
  name: string
  priGrpTypCodeName: string
}

